const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg0(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "217.48 102.261 25.2 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(216, 216, 216)",
      stroke: "rgb(0, 0, 0)"
    },
    points: "217.63 102.261 242.77 102.261 242.77 144.261 217.63 144.261"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(216, 216, 216)",
      stroke: "rgb(0, 0, 0)"
    },
    points: "225.8 147.261 225.8 153.261 234.4 153.261 234.4 147.261"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(216, 216, 216)",
      stroke: "rgb(0, 0, 0)"
    },
    points: "223.78 147.261 236.38 147.261 236.38 144.261 223.78 144.261"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "rgb(0, 0, 0)",
      fill: "hsla(113, 40%, 55%, 1.00)"
    },
    points: "220.63 105.261 220.63 141.261 239.53 141.261 239.53 105.261"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg0);
export default __webpack_public_path__ + "static/media/0.53bb0ffc534d7ee9370ff174fc3462ba.svg";
export { ForwardRef as ReactComponent };